import { useEffect, useRef } from "react";
import { useAuth } from "../hooks/useAuth";
import { fetchCsrfToken } from "../lib/apiClient";

/**
 * Mounts once in the app tree and fetches a CSRF token whenever the user
 * becomes authenticated. Fire-and-forget — a CSRF fetch failure is silently
 * retried on the next mutation via the 403 auto-retry in apiClient.ts.
 *
 * Placed alongside SentryAuthSync in App.tsx so it runs in real app renders
 * but is never imported by unit tests.
 */
export function CsrfInitializer() {
  const { data: context } = useAuth();
  const initialized = useRef(false);

  useEffect(() => {
    if (context && !initialized.current) {
      initialized.current = true;
      fetchCsrfToken().catch(() => {});
    }
    if (!context) {
      initialized.current = false; // reset on logout so next login re-fetches
    }
  }, [context]);

  return null;
}
